/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type CustomerIdentifiedMutationVariables = Types.Exact<{
    requestId: Types.Scalars['ID'];
}>;

export type CustomerIdentifiedMutation = {
    __typename: 'Mutation';
    addEvent_CustomerIdentified: {
        __typename: 'Request';
        publicId: string;
        facts: Types.Maybe<{ __typename: 'RequestFacts'; briefId: Types.Maybe<string> }>;
    };
};

export const CustomerIdentifiedDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'CustomerIdentified' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'requestId' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addEvent_CustomerIdentified' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'requestId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'requestId' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'publicId' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'facts' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'briefId' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type CustomerIdentifiedMutationFn = Apollo.MutationFunction<
    CustomerIdentifiedMutation,
    CustomerIdentifiedMutationVariables
>;

/**
 * __useCustomerIdentifiedMutation__
 *
 * To run a mutation, you first call `useCustomerIdentifiedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerIdentifiedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerIdentifiedMutation, { data, loading, error }] = useCustomerIdentifiedMutation({
 *   variables: {
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useCustomerIdentifiedMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CustomerIdentifiedMutation,
        CustomerIdentifiedMutationVariables
    >
) {
    return Apollo.useMutation<CustomerIdentifiedMutation, CustomerIdentifiedMutationVariables>(
        CustomerIdentifiedDocument,
        baseOptions
    );
}
export type CustomerIdentifiedMutationHookResult = ReturnType<typeof useCustomerIdentifiedMutation>;
export type CustomerIdentifiedMutationResult = Apollo.MutationResult<CustomerIdentifiedMutation>;
export type CustomerIdentifiedMutationOptions = Apollo.BaseMutationOptions<
    CustomerIdentifiedMutation,
    CustomerIdentifiedMutationVariables
>;
